export function reloadPage() {
  try {
    window.location.reload()
  } catch (error) {}
}
